module.exports = __webpack_public_path__ + "media/images/emblems/Movelier-Blazono-2d9767eec460a59799d1956c204610f4.png";